// extracted by mini-css-extract-plugin
export default {"container":"MultipleChoice_container__L26A+","label":"MultipleChoice_label__2PkAB","checkBoxGroup":"MultipleChoice_checkBoxGroup__UzcTS"};